// Expedições: o Eco do personagem (uma cópia da sua vocation) sai em missões por algumas horas enquanto você joga normalmente.
// Ao voltar, entrega uma parte do que você caçaria naquela hunt (experiência e o loot já vendido) e um prêmio extra.
// Quadro com 4 missões que troca todo dia; 2 Ecos (VIP 3). Valores propostos.
export const EXPEDITION_HOURS = [1, 4, 8, 12] as const;
/** quanto do resultado de uma caça offline no mesmo tempo a expedição entrega */
export const EXPEDITION_EFFICIENCY = 0.35;
export const EXPEDITION_SLOTS = { free: 2, vip: 3 };
export const EXPEDITION_REROLL_GOLD = (level: number) => Math.max(1, level) * 200;
export type ExpeditionBonus = 'fragments' | 'preycards' | 'dust' | 'gem' | 'marks';
export const EXPEDITION_BONUS_NAMES: Record<ExpeditionBonus, string> = {
  fragments: 'fragmentos de pedra de proteção', preycards: 'prey cards', dust: 'dust da Forge', gem: 'Lesser Gem', marks: 'marcas do Coliseu',
};
/** prêmio extra pela duração: [tipo, quantidade] */
export function expeditionBonus(hours: number, rnd = Math.random): [ExpeditionBonus, number] {
  const kinds: ExpeditionBonus[] = hours >= 8 ? ['fragments', 'preycards', 'dust', 'gem', 'marks'] : ['fragments', 'preycards', 'dust', 'marks'];
  const k = kinds[Math.floor(rnd() * kinds.length)]!;
  const mult = hours >= 12 ? 3 : hours >= 8 ? 2 : 1;
  const amount = k === 'gem' ? 1 : k === 'dust' ? 20 * mult : k === 'marks' ? 10 * mult : mult;
  return [k, amount];
}
export interface Expedition { id: number; hunt: string; huntName: string; hours: number; bonus: [ExpeditionBonus, number]; monsters?: string[]; level?: number }
/** Patente do Eco: sobe a cada 10 expedições concluídas e aumenta o quanto ele traz (+2% por patente, até +10%). */
export const ECO_RANKS = ['Eco Aprendiz', 'Eco Batedor', 'Eco Explorador', 'Eco Veterano', 'Eco Lendário', 'Eco Imortal'] as const;
export const ECO_RANK_STEP = 10;
export const ecoRank = (done: number) => Math.min(ECO_RANKS.length - 1, Math.floor(done / ECO_RANK_STEP));
export const ecoEfficiency = (done: number) => EXPEDITION_EFFICIENCY + 0.02 * ecoRank(done);
/** selo do contrato pela duração (cor da cera no pergaminho) */
export const CONTRACT_SEALS: Record<number, { name: string; color: string }> = {
  1: { name: 'Contrato de Bronze', color: '#b87333' }, 4: { name: 'Contrato de Prata', color: '#c0c8d0' },
  8: { name: 'Contrato de Ouro', color: '#f0c040' }, 12: { name: 'Contrato Lendário', color: '#c070ff' },
};
export interface ExpeditionSlot { mission: Expedition; ends: number }
export interface ExpeditionState { day: string; board: Expedition[]; slots: ExpeditionSlot[]; seq: number; done: number }
export const emptyExpeditions = (): ExpeditionState => ({ day: '', board: [], slots: [], seq: 0, done: 0 });
